import React from 'react'
import {
  faArrowTrendDown,
  faArrowTrendUp,
  faBan,
  faCartShopping,
  faCheckDouble,
  faClockRotateLeft,
  faGripLines,
} from '@fortawesome/free-solid-svg-icons'
import {
  PixelAlert,
  PixelCurrency,
  PixelFlexBox,
  PixelIcon,
  colors,
} from 'pixel-base'
import styled from 'styled-components'

const tenant_info: ITenantInfo = JSON.parse(
  localStorage.getItem('tenant_info') || '{}',
)
const CardView = (props) => {
  const { data } = props
  const variants = [
    'primary',
    'success',
    'danger',
    'warning',
    'info',
    'light',
    'dark',
    'secondary',
  ]
  data.map((item, index) => {
    item.orders = [
      {
        title: 'Total',
        logo: <PixelIcon fontSize="19px" icon={faCartShopping} />,
        totalOrders: item.total_orders || 0,
        totalOrdersTrend: item.total_orders_trend,
        totalRevenue: item.total_revenue,
        totalRevenueTrend: item.total_revenue_trend,
      },
      {
        title: 'New',
        logo: <PixelIcon fontSize="19px" icon={faCheckDouble} />,
        totalOrders: item.new_orders || 0,
        totalOrdersTrend: item.new_orders_trend,
        totalRevenue: item.new_orders_revenue,
        totalRevenueTrend: item.new_orders_revenue_trend,
      },
      {
        title: 'Delivered',
        logo: <PixelIcon fontSize="19px" icon={faCheckDouble} />,
        totalOrders: item.delivered_orders || 0,
        totalOrdersTrend: item.delivered_orders_trend,
        totalRevenue: item.delivered_revenue,
        totalRevenueTrend: item.delivered_revenue_trend,
      },
      {
        title: 'Processing',
        logo: <PixelIcon fontSize="19px" icon={faCheckDouble} />,
        totalOrders: item.processing_orders,
        totalOrdersTrend: item.processing_orders_trend,
        totalRevenue: item.processing_revenue,
        totalRevenueTrend: null,
      },
      {
        title: 'Tracking',
        logo: <PixelIcon fontSize="19px" icon={faCheckDouble} />,
        totalOrders: item.tracking_orders || 0,
        totalOrdersTrend: item.tracking_orders_trend,
        totalRevenue: item.tracking_revenue,
        totalRevenueTrend: item.tracking_revenue_trend,
      },
      {
        title: 'Cancelled',
        logo: <PixelIcon fontSize="19px" icon={faBan} />,
        totalOrders: item.cancelled_orders || 0,
        totalOrdersTrend: item.cancelled_orders_trend,
        totalRevenue: item.cancelled_revenue,
        totalRevenueTrend: item.cancelled_revenue_trend,
      },
      {
        title: 'Returned',
        logo: <PixelIcon fontSize="19px" icon={faClockRotateLeft} />,
        totalOrders: item.returned_orders || 0,
        totalOrdersTrend: item.returned_orders_trend,
        totalRevenue: item.returned_revenue,
        totalRevenueTrend: item.returned_revenue_trend,
      },
    ]
    item.variant = variants[index]
    return item
  })

  const totalAvg = (total, upto) => {
    return `${(total * upto).toFixed(2)}%`
  }

  return (
    <>
      {data.map((item, index) => {
        return (
          <React.Fragment key={index}>
            <PixelFlexBox
              height="auto"
              justifyContent="flex-start"
              flexDirection="column"
              alignItems="flex-start"
              margin="10px 0px"
            >
              <PixelFlexBox
                justifyContent="flex-start"
                alignItems="flex-start"
                height="auto"
              >
                <SectionTitle>{item.store_name}</SectionTitle>
              </PixelFlexBox>
              <CardBodySection>
                {item?.orders?.map((key, index) => {
                  return (
                    <React.Fragment key={index}>
                      <Card variant={item.variant}>
                        <CardTitle>{key.title}</CardTitle>
                        <PixelFlexBox
                          padding="0px 0px 0px 10px"
                          flexDirection="column"
                        >
                          <PixelFlexBox flexDirection="column">
                            <CardInnerText>
                              Orders&nbsp;&nbsp;&nbsp;
                              <Total
                                color={
                                  key.totalOrdersTrend === 0
                                    ? colors.text
                                    : key.totalOrdersTrend < 0
                                    ? colors.red
                                    : colors.green
                                }
                              >
                                <PixelIcon
                                  fontSize="10px"
                                  icon={
                                    key.totalOrdersTrend === 0
                                      ? faGripLines
                                      : key.totalOrdersTrend < 0
                                      ? faArrowTrendDown
                                      : faArrowTrendUp
                                  }
                                  color={
                                    key.totalOrdersTrend === 0
                                      ? colors.text
                                      : key.totalOrdersTrend < 0
                                      ? colors.red
                                      : colors.green
                                  }
                                />
                                &nbsp;{totalAvg(key.totalOrdersTrend, 100)}
                              </Total>
                            </CardInnerText>
                            <OrdersCount>{key.totalOrders}</OrdersCount>
                          </PixelFlexBox>
                          <PixelFlexBox flexDirection="column">
                            <CardInnerText>
                              Revenue &nbsp;&nbsp;&nbsp;{' '}
                              {key.totalRevenueTrend !== null && (
                                <Total
                                  color={
                                    key.totalRevenueTrend === 0
                                      ? colors.text
                                      : key.totalRevenueTrend < 0
                                      ? colors.red
                                      : colors.green
                                  }
                                >
                                  <PixelIcon
                                    fontSize="10px"
                                    icon={
                                      key.totalRevenueTrend === 0
                                        ? faGripLines
                                        : key.totalRevenueTrend < 0
                                        ? faArrowTrendDown
                                        : faArrowTrendUp
                                    }
                                    color={
                                      key.totalRevenueTrend === 0
                                        ? colors.text
                                        : key.totalRevenueTrend < 0
                                        ? colors.red
                                        : colors.green
                                    }
                                  />
                                  &nbsp;{totalAvg(key.totalRevenueTrend, 100)}
                                </Total>
                              )}
                            </CardInnerText>
                            <span
                              style={{
                                fontSize: '16px',
                              }}
                            >
                              <span
                                style={{
                                  fontSize: '10px',
                                }}
                              >
                                {tenant_info?.default_currency_symbol}
                              </span>
                              <PixelCurrency
                                hideSymbol={true}
                                value={key.totalRevenue}
                              />{' '}
                              &nbsp;
                            </span>
                          </PixelFlexBox>
                        </PixelFlexBox>
                      </Card>
                    </React.Fragment>
                  )
                })}
              </CardBodySection>
            </PixelFlexBox>
          </React.Fragment>
        )
      })}
    </>
  )
}

const Card = styled(PixelAlert)<{ flexEnd?: boolean }>`
  display: flex;
  flex-direction: column;
  border: 1px solid ${colors.grayBorderMedium};
  border-radius: 5px;
  padding: 5px;
  margin: 0px;
  min-height: 90px;
`
const SectionTitle = styled.span`
  font-size: 20px;
  font-weight: bold;
  color: ${(props) => props.color || colors.grayTextDark};
`
const Total = styled.span<{ color?: string }>`
  color: ${(props) => props.color};
  font-size: 10px;
`
const CardBodySection = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 10px;
  width: 100%;
`
const CardTitle = styled.div`
  font-size: 14px;
  width: 100%;
  padding: 5px;
  font-weight: bold;
  color: ${colors.text};
  margin: 0px;
`
const CardInnerText = styled.div<{ justify?: boolean }>`
  font-size: 10px;
  font-weight: 300;
  color: ${colors.text};
  margin: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
`
const OrdersCount = styled.div`
  font-size: 25px;
  font-weight: 500;
  line-height: 25px;
`
export default CardView
